import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";

import AvatarPlaceholderIcon from "../icons/AvatarPlaceholder";

export const Icon = styled(AvatarPlaceholderIcon).attrs({
    fillColor: "#ffffff"
})`
    width: 0.75rem;
`;

const Background = styled.div`
    border-radius: 50%;
    width: 1.5rem;
    height: 1.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${({ active }) => (active ? "#41414d" : "#d4d4d4")};
`;

let AvatarPlaceholder = ({ className, active }) => (
    <Background className={className} active={active}>
        <Icon />
    </Background>
);

AvatarPlaceholder = styled(AvatarPlaceholder)``;

AvatarPlaceholder.propTypes = {
    className: PropTypes.string,
    onClick: PropTypes.func,
    active: PropTypes.bool
};

export { AvatarPlaceholder };
